import React, { useState } from 'react';
import { PlusIcon, MapPinIcon, TagIcon } from '@heroicons/react/24/outline';
import Header from '../Header';
import CityList from './CityList';
import CityForm from './CityForm';
import PackageTypeList from './PackageTypeList';
import PackageTypeForm from './PackageTypeForm';

const CityManagement = () => {
  const [activeTab, setActiveTab] = useState('cities');
  const [showCityForm, setShowCityForm] = useState(false);
  const [showPackageTypeForm, setShowPackageTypeForm] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedPackageType, setSelectedPackageType] = useState(null);

  const tabs = [
    { id: 'cities', name: 'Cities', icon: MapPinIcon },
    { id: 'package-types', name: 'Package Types', icon: TagIcon },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">UAE Cities Management</h1>
          <p className="mt-2 text-gray-600">
            {activeTab === 'cities' 
              ? 'Click on a city to view its freezones and pricing packages'
              : 'Manage package types for pricing structures'
            }
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-8">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm flex items-center space-x-2`}
              >
                <tab.icon className="h-5 w-5" />
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Action Buttons */}
        <div className="mb-6">
          {activeTab === 'cities' && (
            <button
              onClick={() => setShowCityForm(true)}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <PlusIcon className="h-4 w-4 mr-2" />
              Add City
            </button>
          )}
          {activeTab === 'package-types' && (
            <button
              onClick={() => setShowPackageTypeForm(true)}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <PlusIcon className="h-4 w-4 mr-2" />
              Add Package Type
            </button>
          )}
        </div>

        {/* Content */}
        <div className="bg-white shadow rounded-lg">
          {activeTab === 'cities' && (
            <CityList 
              onEdit={(city) => {
                setSelectedCity(city);
                setShowCityForm(true);
              }}
            />
          )}
          {activeTab === 'package-types' && (
            <PackageTypeList
              onEdit={(packageType) => {
                setSelectedPackageType(packageType);
                setShowPackageTypeForm(true);
              }}
              onAdd={() => setShowPackageTypeForm(true)}
            />
          )}
        </div>

        {/* Modals */}
                {showCityForm && (
          <CityForm
            city={selectedCity}
            onClose={() => {
              setShowCityForm(false);
              setSelectedCity(null);
            }}
            onSuccess={() => {
              setShowCityForm(false);
              setSelectedCity(null);
            }}
          />
        )}

        {showPackageTypeForm && (
          <PackageTypeForm
            packageType={selectedPackageType}
            onClose={() => {
              setShowPackageTypeForm(false);
              setSelectedPackageType(null);
            }}
            onSuccess={() => {
              setShowPackageTypeForm(false);
              setSelectedPackageType(null);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CityManagement; 